import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  MenuItem,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import React, {
  Dispatch,
  Fragment,
  ReactNode,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useQuery } from 'react-query';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';
import { useSession, xapi } from '../../hooks/session';
import { schoolListState } from '../../common/atom';
import {
  educationOffices,
  getSchoolClassCount,
  getSchoolGradeCount,
  getSchoolInSchoolGroup,
  schoolGroups,
} from '../../common/helper';
import {
  KEY_SCHOOL_GRADE_SCHOOL_CLASS_LIST,
  KEY_SCHOOL_LIST,
} from '../../common/key';
import {
  getSchoolGradeSchoolClassList,
  getSchoolList,
} from '../../common/api/ApiSchool';

const DEFAULT_WIDTH = '8rem';
interface Props {
  schoolClassInfo: any;
  selectClass: any;
  setSelectClass: Dispatch<SetStateAction<any>>;
}

export const SwClassSelector: React.FC<Props> = ({
  schoolClassInfo,
  selectClass,
  setSelectClass,
}) => {
  const navigate = useNavigate();
  const { loginVal } = useSession();
  const [schoolClassList, setSchoolClassList] = useState<any[]>([]);
  const [schoolClassSeq, setSchoolClassSeq] = useState<number>(0);
  const [schoolGroupSeq, setSchoolGroupSeq] = useState<number>(1);
  const [schoolSeq, setSchoolSeq] = useState<number>(0);
  const [schoolGrade, setSchoolGrade] = useState<number>(0);
  const [schoolClass, setSchoolClass] = useState<string>('0');

  const { refetch: schoolClassRefetch } = useQuery(
    KEY_SCHOOL_GRADE_SCHOOL_CLASS_LIST,
    () => {
      const newData: any = {
        schoolSeq: schoolSeq,
        schoolGrade: schoolGrade,
      };
      if (schoolSeq > 0) return getSchoolGradeSchoolClassList(newData);
      return null;
    },
    {
      onSuccess: res => {
        if (res !== null && res.schoolClassList !== undefined) {
          setSchoolClassList(res.schoolClassList);
        }
      },
      onError: e => {
        console.log(e);
      },
    }
  );

  useEffect(() => {
    schoolClassRefetch();
  }, [schoolSeq, schoolGrade]);

  useEffect(() => {
    if (schoolClassInfo !== undefined && schoolClassInfo.schoolSeq !== 0) {
      setSchoolGroupSeq(schoolClassInfo.schoolGroupSeq);
      setSchoolSeq(schoolClassInfo.schoolSeq);
      setSchoolGrade(0);
      setSchoolClass('0');
    }
  }, [schoolClassInfo]);

  return (
    <Box>
      <Box className='flex_between'>
        <Box className='flex_start'>
          <Box className='flex_start'>
            <TextField
              disabled={loginVal.value.user.roleName === '일반'}
              sx={{ width: '10rem', mr: '.5rem' }}
              select
              value={schoolGrade}
              onChange={evt => {
                setSelectClass({
                  grade: Number(evt.target.value),
                  class: 0,
                });
                setSchoolGrade(Number(evt.target.value));
              }}
            >
              <MenuItem key={`school_grade_${0}`} value={0}>
                학년 전체
              </MenuItem>
              {Array.from(
                { length: getSchoolGradeCount(schoolGroupSeq) },
                (_, index) => (
                  <MenuItem key={`school_grade_${index + 1}`} value={index + 1}>
                    {`${index + 1} 학년`}
                  </MenuItem>
                )
              )}
            </TextField>
            {schoolClassList !== null && schoolClassList.length > 0 ? (
              <TextField
                disabled={loginVal.value.user.roleName === '일반'}
                sx={{ width: '10rem' }}
                select
                value={schoolClass}
                onChange={evt => {
                  setSelectClass({
                    grade: schoolGrade,
                    class: evt.target.value,
                  });
                  setSchoolClass(evt.target.value);
                }}
              >
                <MenuItem key={`school_class_${0}`} value='0'>
                  학급 전체
                </MenuItem>
                {schoolClassList.map((sc: string, index: number) => (
                  <MenuItem key={`school_class_${index + 1}`} value={sc}>
                    {`${sc} 반`}
                  </MenuItem>
                ))}
              </TextField>
            ) : (
              <TextField
                disabled={loginVal.value.user.roleName === '일반'}
                sx={{ width: '10rem' }}
                select
                value={schoolClass}
                onChange={evt => {
                  setSelectClass({
                    grade: schoolGrade,
                    class: evt.target.value,
                  });
                  setSchoolClass(evt.target.value);
                }}
              >
                <MenuItem key={`school_class_${0}`} value='0'>
                  학급 전체
                </MenuItem>
                {Array.from({ length: getSchoolClassCount() }, (_, index) => (
                  <MenuItem key={`school_class_${index + 1}`} value={index + 1}>
                    {`${index + 1} 반`}
                  </MenuItem>
                ))}
              </TextField>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
